const EMPTY_UNITS = {
	networkType: {code: '', name: ''},
	units: {
		unitsByLocality: [],
		unitsByDistance: [],
		unitsSupportAccredited: [],
	},
};

export {EMPTY_UNITS};
